import { classNames } from 'primereact/utils';
import React, { PropsWithChildren, ReactNode } from 'react';

type SegmentProps = PropsWithChildren<{
	title: string;
	className?: string;
	right?: () => ReactNode;
	full?: boolean;
}>;

export const Segment = ({ title, children, className, right, full = false }: SegmentProps) => (
	<div
		className={classNames('flex flex-column gap-2 col-12', {
			'sm:col-6': !full,
		})}
	>
		<div className="flex flex-row gap-2 align-items-center">
			<h3>{title}</h3>
			{right && <div className="ml-auto">{right()}</div>}
		</div>
		<div className={classNames('flex flex-column align-items-start gap-2', className)}>{children}</div>
	</div>
);
